import useMobileDetect from 'use-mobile-detect-hook';

import ripple from './ripple.js';

// Global Selectors ==============================
const rippleSelectors = [
  '.banner__cta .btn', // banner buttons
  '.nav a', // nav buttons
  '.search-form__submit', // search buttons
  '.search-form__field', // search fields
  '.search-form__close', // search buttons
  '.wp-block-button__link', // body buttons
  '.wp-block-file__button', // file buttons
  '.footer__social-bar a', // footer social buttons
  '.wp-block-gce-blog-posts-category-sidebar--list a', // blog category list
  '.gce-blog-loadmore-button', // blog load more articles
  'figure.wp-block-image.has-link figcaption', // images with links
  '.wp-block-gce-gce-blog-posts--card-spotlight a', // blog home featured article
  '.wp-block-gce-blog-posts-feed .excerpt-link-wrap', // blog home article links
  '.latest-posts-link-wrap', // blog post article links
  '.frm_button_submit', // orbis education site formidable form submit button
  '.frm_form_field input', // orbis education site formidable form inputs
  '.frm_form_field textarea', // orbis education site formidable form textarea
  // add new ripple elements here
].join(',');

// Form Selectors ==============================
const rippleFormSelectors = [
  '.custom-select',
  'input[type="text"]',
  'input[type="tel"]',
  'input[type="email"]',
  'button[type="submit"]',
  // add new form elements here
].join(',');

const bindFormControlRipple = (formElement) => {
  Array.from(
    formElement.querySelectorAll(rippleFormSelectors)
  ).forEach(element => element.addEventListener('pointerup', ripple));
};

/**
 * Bind ripple to Form
 * ====================
 * Would use an event delegate, but we can't do that as some form controls stop propagation.
 * So instead we add the events directly on the form elements.
 */
const contentLoadedHandler = () => {
  const targetNode = document.querySelector('.wp-block-gce-gce-form-builder');

  // Callback function to execute when mutations are observed
  const callback = function(mutationsList, observer) {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList' && mutation.target.classList.contains('form-builder')) {
        observer.disconnect();
        const formElement = mutation.target;

        // slight delay for hydration of child elements to bind to
        setTimeout(() => {
          // bind form control (ripple)
          bindFormControlRipple(formElement);
        }, 500);
        return;
      }
    }
  };

  // observe child mutations
  const config = { attributes: false, childList: true, subtree: true };
  const observer = new MutationObserver(callback);
  if (targetNode) {
    observer.observe(targetNode, config);
  }
};

// When the DOM is loaded, run the mutation observer logic
document.addEventListener('DOMContentLoaded', () => {
  const detectMobile = useMobileDetect();

  // desktop only: ripple effect
  if (detectMobile.isDesktop()) {
    // Bind global selectors
    Array.from(
      document.querySelectorAll(rippleSelectors)
    ).forEach((element) => element.addEventListener('pointerup', ripple));

    // Mutation observer for form builder : form elements
    contentLoadedHandler();
  }
});
